import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-waiting",
  "use": "status-waiting-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"status-waiting\"><defs><style>#status-waiting .cls-1{fill:#fff}</style></defs><title>资源 6</title><g id=\"status-waiting_图层_2\" data-name=\"图层 2\"><g id=\"status-waiting_图层_1-2\" data-name=\"图层 1\"><circle class=\"cls-1\" cx=\"9.5\" cy=\"9.5\" r=\"9.5\" /><path d=\"M15.16 3.84a8 8 0 1 0 0 11.32 8 8 0 0 0 0-11.32zm-3.06 8a.65.65 0 0 1-.37.3h-.16a.61.61 0 0 1-.31-.09L8.85 10.6a.72.72 0 0 1-.23-.17c-.3-.17-.46-.36-.46-.54v-4a.65.65 0 0 1 1.3 0v3.69l2.35 1.36a.67.67 0 0 1 .29.89z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/status-waiting.svg
// module id = c9Nk
// module chunks = 6